import { takeLatest, call, take, fork, put, cancel, select, spawn, takeEvery } from 'redux-saga/effects';
import { channel } from 'redux-saga';
import { subscribe, unsubscribe } from '@push-component/client';
import { BYO_EVENT_UPDATES } from '@push-component/constants';
import { BYO_MARKETS_REQUEST, BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_CLEAR_ALL, } from '../constants';
import { hideEventLevelError, showEventLevelError, marketFetchingStarted, saveMarkets, updateSelectionsInSlip, saveMarketsUpdates, callPriceAction, } from '../actions';
import { getMarketsData } from '../../dataProviders';
import { modifySlipSelections } from './slipSagas/utils';
import config from '../../config';
import { EN_GB_LOCALE, EN_LOCALE, EE_LOCALE, PUSH_SUBSCRIBE_OWNER } from '../../constants';
const subscribeChannel = channel();
let updateTask;
const shortLocale = config.locale === EN_GB_LOCALE ? EN_LOCALE : EE_LOCALE;
export function* cancelEventUpdatesTask() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        unsubscribe({
            owner: PUSH_SUBSCRIBE_OWNER,
            type: BYO_EVENT_UPDATES,
            locale: shortLocale,
            eventId,
        });
    }
    if (updateTask && !updateTask.isCancelled()) {
        yield cancel(updateTask);
    }
}
const selectionsChanged = (selA, selB) => JSON.stringify(selA) !== JSON.stringify(selB);
export function* updateEventUpdatesSaga(eventId) {
    if (eventId) {
        subscribe({
            owner: PUSH_SUBSCRIBE_OWNER,
            type: BYO_EVENT_UPDATES,
            locale: shortLocale,
            eventId,
            callback: subscribeChannel.put,
        });
        while (true) {
            const action = yield take(subscribeChannel);
            yield put(saveMarketsUpdates(action.data));
            const selectionsInSlip = yield select(state => state.slip.selections);
            const expiredSelections = yield select(state => state.slip.expiredSelections);
            const modifiedSlipSelections = modifySlipSelections(selectionsInSlip, action.data.byoMarketGroups, expiredSelections);
            yield put(updateSelectionsInSlip(modifiedSlipSelections));
            if (selectionsChanged(selectionsInSlip, modifiedSlipSelections)) {
                yield put(callPriceAction());
            }
        }
    }
}
export function* clearAllSaga() {
    yield call(cancelEventUpdatesTask);
}
export function* enableUpdateEventTask() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        updateTask = yield spawn(updateEventUpdatesSaga, eventId);
    }
}
export function* getMarketsSaga(action) {
    try {
        const { locale, eventId, useBYOFreedom } = action.payload;
        yield put(hideEventLevelError());
        yield put(marketFetchingStarted());
        const response = yield call(getMarketsData, locale, eventId, useBYOFreedom);
        yield put(saveMarkets(response));
        yield call(cancelEventUpdatesTask);
        updateTask = yield spawn(updateEventUpdatesSaga, eventId);
    }
    catch (error) {
        yield put(showEventLevelError(error.toString()));
    }
}
export function* getMarketsWatcher() {
    yield takeLatest(BYO_MARKETS_REQUEST, getMarketsSaga);
}
export function* startEventUpdatesSubscription() {
    yield takeEvery(BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION, enableUpdateEventTask);
}
export function* stopEventUpdatesSubscription() {
    yield takeEvery(BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION, cancelEventUpdatesTask);
}
export function* clearAllMarketsWatcher() {
    yield takeEvery(BYO_MARKETS_CLEAR_ALL, clearAllSaga);
}
const marketsSagas = [
    fork(getMarketsWatcher),
    fork(startEventUpdatesSubscription),
    fork(stopEventUpdatesSubscription),
    fork(clearAllMarketsWatcher)
];
export default marketsSagas;
